import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { EASE_REFINED } from './constants';
import CategoryTag from './CategoryTag';
import FadeIn from './FadeIn';

export default function FeaturedArticle({ post }) {
  if (!post) return null;

  const initials = post.author.split(' ').map((w) => w[0]).join('');

  return (
    <FadeIn delay={0.1}>
      <Link to={`/blog/${post.slug}`} className="featured-article-link">
        <motion.article
          className="luxury-card featured-article"
          whileHover={{ y: -4 }}
          transition={{ duration: 0.4, ease: EASE_REFINED }}
        >
          <div className="featured-article__gradient" aria-hidden="true" />
          <div className="featured-article__content">
            <div className="featured-article__tags">
              <CategoryTag label={post.category} />
              <span className="section-tag">Featured</span>
            </div>
            <h2 className="landing-heading featured-article__title">{post.title}</h2>
            <p className="featured-article__excerpt">{post.excerpt}</p>
            <div className="featured-article__meta">
              <div className="featured-article__author-avatar" aria-hidden="true">
                {initials}
              </div>
              <div>
                <div className="featured-article__author-name">{post.author}</div>
                <div className="featured-article__author-meta">
                  {post.date} · {post.readTime}
                </div>
              </div>
              <span className="featured-article__read">
                Read
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true">
                  <path
                    d="M2 6h8M7 3l3 3-3 3"
                    stroke="currentColor"
                    strokeWidth="1"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </span>
            </div>
          </div>
        </motion.article>
      </Link>
    </FadeIn>
  );
}
